/** All times shown in the app are Thailand time, whatever the device's time zone. */
export const TH_TZ = 'Asia/Bangkok';

export const thTime = (d: Date) =>
  d.toLocaleTimeString('th-TH', { timeZone: TH_TZ, hour: '2-digit', minute: '2-digit' });

/** "13 ต.ค. 09:55" in Thailand time (date and time for lists). */
export const thDateTime = (d: Date) =>
  d.toLocaleString('th-TH', { timeZone: TH_TZ, day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' });

/** "2026-10-13 0605" in Thailand time, for file names (Gregorian year, digits only). */
export function thStamp(d: Date): string {
  const parts = new Intl.DateTimeFormat('en-GB', {
    timeZone: TH_TZ, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
  }).formatToParts(d);
  const get = (t: string) => parts.find(p => p.type === t)?.value ?? '';
  return `${get('year')}-${get('month')}-${get('day')} ${get('hour')}${get('minute')}`;
}
